import { render, staticRenderFns } from "./PaymentAdmin.vue?vue&type=template&id=94757dc0&scoped=true"
import script from "./PaymentAdmin.vue?vue&type=script&lang=js"
export * from "./PaymentAdmin.vue?vue&type=script&lang=js"
import style0 from "./PaymentAdmin.vue?vue&type=style&index=0&id=94757dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94757dc0",
  null
  
)

export default component.exports